module.exports = __webpack_public_path__ + "static/media/f5-icon-ss.c9f1f659.png";